<template>
  <v-list dense nav>
    <v-list-group
      v-if="profile"
      :prepend-icon="profile.icon"
      append-icon="mdi-menu-down"
      :color="
        barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'
          ? 'white'
          : 'grey darken-1'
      "
    >
      <template v-slot:activator>
        <v-list-item-avatar
          v-if="profile.avatar"
          class="align-self-center"
          color="grey"
        >
          <v-img v-if="profile.photoURL" :src="profile.photoURL" />
          <v-icon v-else dark>mdi-account-circle</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="profile.title" />
        </v-list-item-content>
      </template>

      <v-list-item
        to="/settings/profile"
        :active-class="`primary ${!isDark ? 'black' : 'white'}--text`"
      >
        <v-list-item-icon class="v-list-item__icon--text" v-text="'EP'" />
        <v-list-item-content>
          <v-list-item-title v-text="this.$t('edit-profile')" />
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="logout">
        <v-list-item-icon class="v-list-item__icon--text" v-text="'L'" />
        <v-list-item-content>
          <v-list-item-title v-text="'Log out'" />
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'UserInformation',
  data() {
    return {
      isDark: true,
    };
  },
  computed: {
    ...mapState({
      barColor: (state) => state.barColor,
      user: (state) => state.user.user,
    }),
    profile() {
      let obj = null;
      if (this.user) {
        obj = {
          avatar: true,
          group: '',
          title: this.user.displayName,
          photoURL: this.user.photoURL,
          children: [
            {
              to: '/settings/profile',
              title: this.$t('edit-profile'),
            },
            {
              to: '',
              title: this.$t('settings'),
            },
          ],
        };
      }

      return obj;
    },
  },
  methods: {
    ...mapActions('user', ['singOut']),
    logout() {
      this.singOut();
      this.$router.push('/user/login');
    },
  },
};
</script>

<style>
.v-list-group__activator p {
  margin-bottom: 0;
}
</style>
